import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import plaka from '@/store/modules/plaka'
import design from '@/store/modules/design'
import user from '@/store/modules/user'
import createLogger from '@/plugins/logger'
import { IS_DEBUG_MODE } from '@/enviroment/global'
const PERSISTANCE_STORE_KEY = 'plakastore'

Vue.use(Vuex)

export { PLAKA } from '@/store/modules/plaka'
export { USER } from '@/store/modules/user'
export { DESIGN } from '@/store/modules/design'
export const Store = new Vuex.Store({
  strict: IS_DEBUG_MODE,
  modules: {
    plaka,
    user,
    design
  },
  plugins: [
    createPersistedState({
      key: PERSISTANCE_STORE_KEY
    }),
    createLogger()
  ]
})
